import { faCat, faDog } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function CompanionKnowledgeSection({ knowledge }) {
  if (!knowledge?.length) {
    return null;
  }

  const faSpeciesMap = {
    dog: faDog,
    cat: faCat,
  };

  const knowledgeMap = knowledge.reduce((a, b) => {
    a[b.knowledgeKey] = b.knowledgeValue;
    return a;
  }, {});

  return (
    <div className="bg-indigo-500 bg-opacity-10 text-black p-2 m-2 rounded-xl">
      <div className="font-bold text-2xl text-indigo-500 mb-2">
        Patient Insights
      </div>
      {knowledgeMap?.pet_name && (
        <div className="font-bold text-lg">
          {knowledgeMap.pet_name}
        </div>
      )}
      {Object.keys(knowledgeMap).filter((i) =>
        ["pet_species", "pet_age", "pet_breed"].includes(i),
      ).length > 0 && (
        <div className="flex justify-between ">
          <div className="text-gray-600 font-bold">
            {knowledgeMap.pet_breed}
          </div>
          <div className="flex gap-2 items-center">
            {knowledgeMap.pet_age && (
              <span className="text-gray-600">
                {knowledgeMap.pet_age}yo
              </span>
            )}
            {faSpeciesMap?.[knowledgeMap.pet_species] && (
              <FontAwesomeIcon
                className="text-blue-500"
                size="lg"
                icon={faSpeciesMap[knowledgeMap.pet_species]}
              />
            )}
          </div>
        </div>
      )}
      {/* <hr className="h-px bg-gray-300 border-0 my-2" /> */}
    </div>
  );
}
